// extracted by mini-css-extract-plugin
export default {"mesPageSection":"styles_mesPageSection__fgFPV","tab":"styles_tab__SPSeR","tabLabel":"styles_tabLabel__63q2m","day":"styles_day__OKzKS"};